import { DataTestAttributes } from "interfaces/data-test-attributes";
import React, { PropsWithChildren } from "react";
import TableOfContentsBookmarkIndicator from "organisms/table-of-contents/table-of-contents-bookmark-indicator";
import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import useVirtualTableOfContents from "pages/notebooks/notebook-reference-panel/bookview/use-virtual-table-of-contents";
import PublicationComponentType from "utilities/enumerations/publication-component-type";

interface TableOfContentsCollapsePanelLinkWithinPanelProps
    extends Pick<
        DataTestAttributes,
        "dataTestDisplaySequence" | "dataTestExternalId" | "dataTestId"
    > {
    hasBookmark?: boolean;
    index?: number | string;
    isPublic?: boolean;
    onClick?: () => void;
    useRelativePath?: boolean;
    caapsId?: string | number;
    publicationComponentType?: PublicationComponentType;
    parentId?: string;
}

const CSS_CLASS_NAME = "c-virtual-table-of-contents";

const TableOfContentsCollapsePanelLinkWithinPanel: React.FunctionComponent<
    PropsWithChildren<TableOfContentsCollapsePanelLinkWithinPanelProps>
> = (props) => {
    const {
        children,
        dataTestId,
        hasBookmark = false,
        index,
        caapsId,
        publicationComponentType = PublicationComponentType.Section,
        parentId,
    } = props;

    const { onNavigationClick } = useVirtualTableOfContents();

    const notebookRouteToPublication = () => {
        onNavigationClick(caapsId, publicationComponentType, parentId);
    };

    return (
        <li className={`${CSS_CLASS_NAME}__listItem`} key={index}>
            <Button
                cssClassName={`${CSS_CLASS_NAME}__listItemButton`}
                dataTestId={dataTestId}
                style={ButtonStyles.Text}
                onClick={notebookRouteToPublication}>
                {children}
                <TableOfContentsBookmarkIndicator hasBookmark={hasBookmark} />
            </Button>
        </li>
    );
};

export default TableOfContentsCollapsePanelLinkWithinPanel;
